import * as lazyIndex from './lazyIndex';
import * as lazyIndexLoadItemReadingPane from './lazyIndexLoadItemReadingPane';
import { LazyAction, LazyModule } from 'owa-bundling';
import { lazyActionWithErrorHandler } from 'mini-error-handler/lib/utils/lazyActionWithErrorHandler';
import { LoadConversationReadingPaneState } from './actions/loadConversationReadingPane';

const lazyModule = new LazyModule(() =>
    System.import<typeof lazyIndex>(/* webpackChunkName: "ReadingPane" */ './lazyIndex')
);
const lazyModuleLoadItemReadingPane = new LazyModule(() =>
    System.import<typeof lazyIndexLoadItemReadingPane>(
        /* webpackChunkName: "ItemReadingPane" */ './lazyIndexLoadItemReadingPane'
    )
);

export const lazyLoadConversationReadingPane = new LazyAction(
    lazyModule,
    m => m.loadConversationReadingPane
);

export const lazyLoadItemReadingPane = new LazyAction(
    lazyModuleLoadItemReadingPane,
    m => m.loadItemReadingPane
);

export const lazyLoadedItemReadingPaneErrorHandled = lazyActionWithErrorHandler(
    lazyLoadItemReadingPane
);

export { LoadConversationReadingPaneState };
